<template>
  <section class="path">
    <div class="container">
      <a-typography-title :level="1">
        开发者成长路径
      </a-typography-title>
      <a-typography-paragraph>
        我们从开发者的需求出发来运营社区，帮助其快速成长。
      </a-typography-paragraph>
      <div class="box_list">
        <a-row class="title">
          <a-col :span="6">
            级别
          </a-col>
          <a-col :span="9">
            如何达成
          </a-col>
          <a-col :span="9">
            奖励
          </a-col>
        </a-row>
        <a-row v-for="(item,index) in expand.list"
               class="item">
          <a-col :xs="24" :md="6">
            <div class="icon">
              <a-typography-title :level="5">
                {{ item.title }}
                <span>{{ item.title_en }}</span>
              </a-typography-title>
              <div>
                <i v-for="v in (index+1)" />
              </div>
            </div>
          </a-col>
          <a-col :xs="24" :md="18">
            <div v-for="v in item.content"
                 class="content">
              <div class="box_achieve">
                <a-typography-title :level="5">
                  如何达成
                </a-typography-title>
                <p v-for="vv in v.achieve"
                   :class="{active:vv.includes('个被合并的 PR')}">
                  {{ vv }}
                </p>
              </div>
              <div class="box_award">
                <a-typography-title :level="5">
                  奖励
                </a-typography-title>
                <div v-for="vv in v.award">
                  <i :class="`i_${vv.icon}`" />
                  {{ vv.name }}
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'community_path',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '社区贡献者',
            title_en: 'Contributor',
            content: [
              {
                achieve: [
                  '1个被合并的 PR'
                ],
                award: [
                  {
                    name: '记事本',
                    icon: 1
                  }
                ]
              },
              {
                achieve: [
                  '3个被合并的 PR'
                ],
                award: [
                  {
                    name: '证书',
                    icon: 2
                  },
                  {
                    name: '鼠标垫',
                    icon: 3
                  }
                ]
              }
            ]
          },
          {
            title: '社区活跃贡献者',
            title_en: 'Active Contributor',
            content: [
              {
                achieve: [
                  '5个被合并的 PR',
                  '或者修复重大bug'
                ],
                award: [
                  {
                    name: '键盘',
                    icon: 4
                  }
                ]
              }
            ]
          },
          {
            title: '社区核心贡献者',
            title_en: 'Committer',
            content: [
              {
                achieve: [
                  '对星汉未来开源项目的原理有深入理解',
                  '有能力及时处理项目出现的各种问题',
                  '主导过一次重要开发，并撰写和修订相关的文档',
                  '获得至少一位 PMC 提名，并通过投票'
                ],
                award: [
                  {
                    name: '工作机会推荐',
                    icon: 5
                  }
                ]
              }
            ]
          },
          {
            title: '社区顾问',
            title_en: '',
            content: [
              {
                achieve: [
                  '从Committer中诞生',
                  '可主动申请，社区也会定向邀请'
                ],
                award: [
                  {
                    name: '项目合作邀约',
                    icon: 6
                  }
                ]
              }
            ]
          },
          {
            title: '社区委员会',
            title_en: 'PMC',
            content: [
              {
                achieve: [
                  '深度理解星汉未来开源项目的原理',
                  '对星汉未来开源社区的未来规划有清晰的理解',
                  '有能力及时处理项目出现的各种问题',
                  '主导项目的开发和迭代，把控项目整体优化方向',
                  '获得至少一位 PMC 提名，并通过投票'
                ],
                award: [
                  {
                    name: '深度参与开源项目共建',
                    icon: 7
                  }
                ]
              }
            ]
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';
@image: '@{src_image}page/community/';
@border: 1px solid @color_15;
@pl: 20px 20px 20px 30px;

.bgDecorate(@scale:1) {
  .bg('@{image}path_decorate.png', 90px*@scale, 56px*@scale);
}

.path {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.box_list {
  position: relative;
  margin: @margin_mo 0 0;
  
  .ant-row {
    .ant-col {
      position: relative;
    }
  }
  
  .title {
    .font(left, @text_big+20px, @color_white, @text_big, true);
    .bg('@{image}path_bg.png');
    background-size: cover;
    
    .ant-col {
      padding: @pl;
    }
  }
  
  .item {
    background: @color_white;
    
    .ant-col {
      display: flex;
      flex-direction: column;
      border: @border;
      border-top: none;
      
      &:nth-child(1) {
        justify-content: center;
      }
      
      &:nth-child(2) {
        border-left: none;
      }
    }
    
    .icon {
      overflow: hidden;
      padding: 20px;
      text-align: center;
      
      &::before {
        @wh: 56px;
        content: '';
        display: block;
        width: @wh;
        height: @wh;
        margin: 0 auto;
        .bgDecorate();
        background-position: 0 0;
      }
      
      h5.ant-typography {
        margin: @padding_mo 0 0;
        .font(center, @text, @color_12, @text, true);
        
        span {
          display: block;
          margin: 5px 0 0;
          .font(center, @text, @color_13, @text);
        }
      }
      
      div {
        width: 96px;
        padding: 5px 0;
        margin: @padding_mo auto 0;
        .bg('@{image}path_bg.png');
        background-size: cover;
        border-radius: 10px;
        font-size: 0;
        
        i {
          display: inline-block;
          width: 12px;
          height: 11px;
          margin: 0 2px;
          .bgDecorate(0.5);
          background-position: -58px*0.5 0;
        }
      }
    }
    
    .content {
      flex: 1;
      display: flex;
      flex-direction: row;
      
      &:not(&:first-child) {
        border-top: @border;
      }
      
      .box_achieve,
      .box_award {
        display: flex;
        position: relative;
        padding: @pl;
        .borderBox();
        
        h5.ant-typography {
          display: none;
          .position(left);
          width: 30px;
          height: 100%;
          .font(center, @text+2px, @color_white, @text, true);
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .bg('@{image}path_bg.png');
          background-size: cover;
        }
      }
      
      .box_achieve {
        flex: 1;
        flex-direction: column;
        justify-content: center;
        
        p {
          position: relative;
          padding-left: 22px;
          margin: 0;
          .font(justify, @text+@line, @color_13, @text);
          
          &.active {
            color: #2087FF;
          }
          
          &::before {
            content: '';
            display: block;
            .position(absolute, 5px, auto, auto, 0);
            width: 16px;
            height: 16px;
            margin: auto 0;
            border-radius: 50%;
            .bgDecorate(0.5);
            background-position: -58px*0.5 -24px*0.5;
          }
        }
      }
      
      .box_award {
        flex: 1;
        align-items: center;
        border-left: @border;
        
        div {
          position: relative;
          width: 100px;
          .font(center, @text, @color_13, @text);
          
          i {
            @wh: 30px;
            display: block;
            position: relative;
            width: @wh+10px;
            height: @wh+10px;
            margin: 0 auto 5px;
            border: 1px solid #2185FF;
            border-radius: 50%;
            .borderBox();
            
            .loop(@i) when (@i<=7) {
              &.i_@{i}::before {
                background-position: -@wh*(-1+@i) 0;
              }
              .loop(@i+1);
            }
            .loop(1);
            
            &::before {
              content: '';
              display: block;
              .position();
              width: @wh;
              height: @wh;
              margin: auto;
              .bg('@{image}path_icon.png', @wh*7, @wh);
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .path {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
  }
  
  .box_list {
    .title {
      display: none;
    }
    
    .item {
      margin-top: 10px;
      
      .icon {
        &::before {
          @scale: 0.65;
          @wh: 56px*@scale;
          float: left;
          width: @wh;
          height: @wh;
          margin: 0;
          .bgDecorate(@scale);
          background-position: 0 0;
        }
        
        h5.ant-typography {
          float: left;
          margin: 0 0 0 10px;
          .font(left, @text_mo, @color_12, @text_mo, true);
          
          span {
            .font(left, @text_mo, @color_13, @text_mo);
          }
        }
        
        div {
          float: right;
        }
      }
      
      .content {
        flex-direction: column;
        
        .box_achieve,
        .box_award {
          padding: 25px 20px 25px 45px;
          
          h5.ant-typography {
            display: flex;
          }
        }
        
        .box_achieve {
          border-left: @border;
        }
        
        .box_award {
          border-top: @border;
        }
      }
    }
  }
}
</style>